rjm.ui.ChartBuilderCohortTimeOptionsView = rjm.ui.ChartBuilderDropdownView.extend(
  id: "cbCohortTime"
  className: "span"

  events:
    "click .btn.dropdown-toggle.timePeriod": "toggleDropdown"
    "click #saveCohortTimeOptions": "save"
    "input div.interval input": "isValid"

  initialize: (options) ->
    if not options or not options.chartModel
      throw "InvalidConstructorArgs - ChartBuilderCohortTimeOptionsView"

    _.bindAll this, "listenToCohortField", "isValid", "tabChanged", "generateAllCohortList", "getTypeDescription", "generateTemplateData", "setActiveTabs", "setActiveLinks", "save", "setCohortToAll", "enablePopover", "disablePopover", "handleExternalClickEvent", "renderSubViews", "toggleDropdown", "render"
    @chartModel = options.chartModel
    @timeFrameModel = @chartModel.get("timeFrame")
    @cohortDescriptor = @chartModel.getCurrentSeries().get("cohortDescriptor")
    @cohortList = null
    @activeType = @cohortDescriptor.get("type")
    @open = false

    @specificCohortOptions = new rjm.ui.ChartBuilderCohortTimeOptionsSpecificView
      cohortDescriptor: @cohortDescriptor

    @movingCohortOptions = new rjm.ui.ChartBuilderCohortTimeOptionsMovingView
      cohortDescriptor: @cohortDescriptor

    @allCohortOptions = new rjm.ui.ChartBuilderCohortTimeOptionsAllView
      cohortDescriptor: @cohortDescriptor

    if @cohortDescriptor.get("cohortField")?
      @listenToCohortField()
    @listenTo @chartModel.getCurrentSeries(), "change:trend", @render
    @listenTo @chartModel, "change:timeInterval", (chartModel, options) =>
      @generateAllCohortList()
      @cohortDescriptor.adjustStartTimes(@cohortList)
      @renderSubViews()
      @enablePopover()
    @listenTo @cohortDescriptor, "change:cohortField", (cohortDescriptor, options) =>
      if cohortDescriptor.previous("cohortField")?
        @stopListening(cohortDescriptor.previous("cohortField"))
      @listenToCohortField()

    return

  listenToCohortField: ->
    @listenTo @cohortDescriptor.get("cohortField"), "change:minTime", (cohortField, options) =>
      if cohortField.get("minTime")?
        @generateAllCohortList()
        @renderSubViews()
        @enablePopover()
      else
        @specificCohortOptions.block()
        @allCohortOptions.block()

      return

  isValid: (e) ->
    if parseInt($(e.target).val()) >= 0
      @$("#saveCohortTimeOptions").removeClass("disabled")
    else
      @$("#saveCohortTimeOptions").addClass("disabled")

  tabChanged: (e) ->
    switch @$(e.target).attr("class")
      when "movingCohorts"
        @activeType = rjm.app.enums.cohortDescriptorType.MOVING
        @delegateEvents()
      when "specificCohorts"
        @activeType = rjm.app.enums.cohortDescriptorType.EXPLICIT
      when "allCohorts"
         @activeType = rjm.app.enums.cohortDescriptorType.ALL

    return

  generateAllCohortList: ->
    if @cohortDescriptor.get("cohortField").get("minTime") is -1
      @cohortList = -1
      return
    minTime = @cohortDescriptor.cleanMoment(moment(@cohortDescriptor.get("cohortField").get("minTime")))
    interval = @chartModel.get("timeInterval")
    unless interval?
      return
    now = moment().valueOf()
    cohortList = []
    while minTime.valueOf() < now
      cohortList.push
        date: @cohortDescriptor.dateToString(minTime)
        timestamp: minTime.valueOf()/1000 #the underlying system wants everything is seconds so chop off the unneeded precision
      if  @chartModel.get("timeInterval") is rjm.app.enums.timeInterval.QUARTER
        minTime.add(3, "months")
      else
        minTime.add(1, (interval.serializedValue + "s").toLowerCase())

    @cohortList = cohortList
    return

  getTypeDescription: ->
    switch @cohortDescriptor.get("type")
      when rjm.app.enums.cohortDescriptorType.MOVING
        return (
          timePeriodDescription: "a Moving Set of Cohorts" 
          helpText: "over"
        )

      when rjm.app.enums.cohortDescriptorType.EXPLICIT
        return (
          timePeriodDescription: "Specific Cohorts"
          helpText: "over"
        )

      when rjm.app.enums.cohortDescriptorType.ALL
        return (
          timePeriodDescription: "All Cohorts"
          helpText: "over"
        )

   generateTemplateData: ->
    {timePeriodDescription, helpText} = @getTypeDescription()
    return (
      timeFrames: rjm.app.enums.timeFrameType
      framePropertyName: "names"
      currentTimeFrame: @timeFrameModel.get("type").serializedValue
      timePeriodDescription: timePeriodDescription
      helpText: helpText
    )

  #activate/deactivate the moving/specific tab(s)
  setActiveTabs: (moving, specific, all) ->
    @$(".movingCohorts").parent().toggleClass("active", moving)
    @$("#movingCohorts").toggleClass("active", moving)
    @$(".specificCohorts").parent().toggleClass("active", specific)
    @$("#specificCohorts").toggleClass("active", specific)
    @$("#allCohorts").toggleClass("active", all)
    @$(".allCohorts").parent().toggleClass("active", all)

  #sets the appropriate links as active based on the current model state
  setActiveLinks: ->
    @setActiveTabs false, false
    switch @cohortDescriptor.get("type")
      when rjm.app.enums.cohortDescriptorType.MOVING
        @setActiveTabs true, false, false
      when rjm.app.enums.cohortDescriptorType.EXPLICIT
        #make the specific date range tab active
        @setActiveTabs false, true, false
      when rjm.app.enums.cohortDescriptorType.ALL
        #make the All-Time quick link active and deactivate all tabs
        @setActiveTabs false, false, true

  save: (e) ->
    e.preventDefault()
    if $(e.target).hasClass("disabled")
      return
    switch @activeType
      when rjm.app.enums.cohortDescriptorType.MOVING
        @movingCohortOptions.save(e)
        @cohortDescriptor.unset("startTimes", {silent: true})
        @cohortDescriptor.unset("startTimes", {silent: true})
      when rjm.app.enums.cohortDescriptorType.EXPLICIT
        if @cohortDescriptor.get("cohortField").get("minTime") is -1
          @setCohortToAll()
        else
          @specificCohortOptions.save(e)
          @cohortDescriptor.unset("startTime", {silent: true})
      when rjm.app.enums.cohortDescriptorType.ALL
        if @cohortDescriptor.get("cohortField").get("minTime") is -1
          @setCohortToAll()
        else
          @allCohortOptions.save(e)
          @cohortDescriptor.unset("startTimes", {silent: true})

    @cohortDescriptor.change()
    @open = false
    @render()

    return

  setCohortToAll: ->
    @cohortDescriptor.set
      startTime: null
      type: rjm.app.enums.cohortDescriptorType.ALL
    ,
      silent: true

    return

  enablePopover: ->
    @$("a.timePeriod").popover 'destroy'
    switch @cohortDescriptor.get("type")
      when rjm.app.enums.cohortDescriptorType.MOVING
        @$("a.timePeriod").popover
          trigger: 'hover'
          title: 'Moving Cohort'
          container: 'body'
          html: true
          content: 'The most recent <bold>' + @cohortDescriptor.get("count") + ' cohorts</bold> with at least <bold>' + @cohortDescriptor.get("minimumIntervals") + ' ' + rjm.app.enums.timeInterval[@cohortDescriptor.get("timeInterval")].names.toLowerCase() + '(s)</bold> of data.'
          placement: 'bottom'
      when rjm.app.enums.cohortDescriptorType.ALL
        if @cohortDescriptor.get("startTime")?
          contentText = moment(@cohortDescriptor.get("startTime")).format("MMMM D, YYYY")
          @$("a.timePeriod").popover
            trigger: 'hover'
            title: 'All Cohorts'
            container: 'body'
            content: 'All cohorts from '+ contentText + ' to now.'
            placement: 'bottom'


  disablePopover: ->
    @$("a.timePeriod").popover 'destroy'
    return

  handleExternalClickEvent: (e) ->
    e = rjm.ui.ChartBuilderDropdownView.prototype.handleExternalClickEvent.call(this, e)
    if @open and e.handled
      @open = false
      @enablePopover()
    return

  renderSubViews: ->
    @specificCohortOptions.setCohortList(@cohortList)
    @specificCohortOptions.setElement(@$("#specificCohorts")).render()  
    @movingCohortOptions.setElement(@$("#movingCohorts")).render()
    @allCohortOptions.setCohortList(@cohortList)
    @allCohortOptions.setElement(@$("#allCohorts")).render()
    return

  toggleDropdown: (e) ->
    e?.preventDefault()
    $(e.target).find('~.dropdown-menu').toggle()
    #set the ui tab elements appropriately
    @setActiveLinks()
    unless @open
      @renderSubViews()
      @disablePopover()
      @open = true
    else
      @open = false
      @enablePopover()
    return

  render: ->
    $(@el).html ich.chartBuilderCohortOptions(@generateTemplateData())

    @$('a[data-toggle="tab"]').on 'shown', @tabChanged

    #set or remove the dropdown label
    @enablePopover()

    return @
)
